module.exports = __webpack_public_path__ + "img/saum_enzianblau_ral5010.c827d5cf.jpg";